import React from 'react'
import { Button } from "@material-ui/core";

const SpecialCaseBirth = () => {
  return (
    <>
    <p>Informationen zum normalen Ablauf einer Geburt bei der Hündin findest Du z.B. <a href="https://www.petplan.de/geburt-und-anzeichen-von-wehen-bei-hunden" target='_blank' >hier</a></p>

    <p>Die wichtigsten Anzeichen für Geburtskomplikationen sind:</p>
    <ul>
      <li>
      `{'>'}` 3 Stunden nach dem Beginn der regelmäßigen Presswehen ohne das etwas passiert
      </li>
      <li>
      Fruchtblase geplatzt ist, stark grüne Flüssigkeit zum Vorschein kommt, der Welpe aber weiterhin im Geburtstrakt steckt
      </li>
      <li>
      `{'>'}` 2 Stunden zwischen der Geburt von zwei Welpen
      übermäßig großer Blutverlust
      </li>
      <li>
      Die Nachgeburt auch nach 3 Stunden nicht austritt

      </li>
    </ul>
    <p>Sollten eine dieser Fälle zutreffen, findest Du hier die <Button
            variant='contained'
            color='primary'
            type='submit'
            onClick={(e) => handleUnsicherResult(e, 'notfall')}
            className='button--next'
          >Tnächste Notdienstklinik</Button></p>
          <p>Wenn Du Dir unsicher bist empfehlen wir Dir, dich zunächst <Button
            variant='contained'
            color='primary'
            type='submit'
            onClick={(e) => handleUnsicherResult(e, 'telefonisch')}
            className='button--next'
          >telefonisch</Button> beraten zu lassen.</p>
  </>
  )
}

export default SpecialCaseBirth
